import App from "@/controllers/app";
import Applicant from "@/controllers/applicant";
import Appointment from "@/controllers/appointment";
import AuditCharge from "@/controllers/audit_charge";
import BaseRate from "@/controllers/base_rate";
import Calendar from "@/controllers/calendar";
import Carrier from "@/controllers/carrier";
import Client from "@/controllers/client";
import Company from "@/controllers/company";
import Container from "@/controllers/container";
import DataGrid from "@/controllers/data_grid";
import DayLog from "@/controllers/day_log";
import Discount from "@/controllers/discount";
import DriverDoc from "@/controllers/driver_doc";
import ETabs from "@/controllers/etabs";
import EModal from "@/controllers/emodal";
import Geo from "@/controllers/geo";
import Invoice from "@/controllers/invoice";
import MapMarker from "@/controllers/map_marker";
import Operation from "@/controllers/operation";
import Paginate from "@/controllers/paginate";
import Payment from "@/controllers/payment";
import Performance from "@/controllers/performance";
import PreAlert from "@/controllers/pre_alert";
import Reconciliation from "@/controllers/reconciliation";
import Sidebar from "@/controllers/sidebar";
import Signature from "@/controllers/signature";
import Topbar from "@/controllers/topbar";
import Trucker from "@/controllers/trucker";
import TruckerEmail from "@/controllers/trucker_email";
import VolumeDeviation from "@/controllers/volume_deviation";
import Web from "@/controllers/web";
import "@/controllers/forms/add_fields";
import "@/controllers/forms/remove_fields";
import "@/controllers/forms/observer";

window.NApp = App;
window.Applicant = Applicant;
window.Appointment = Appointment;
window.AuditCharge = AuditCharge;
window.BaseRate = BaseRate;
window.ETabs = ETabs;
window.EModal = EModal;
window.Calendar = Calendar;
window.Carrier = Carrier;
window.Client = Client;
window.Company = Company;
window.Container = Container;
window.DataGrid = DataGrid;
window.DayLog = DayLog;
window.Discount = Discount;
window.DriverDoc = DriverDoc;
window.Geo = Geo;
window.MapMarker = MapMarker;
window.Invoice = Invoice;
window.Operation = Operation;
window.Paginate = Paginate;
window.Payment = Payment;
window.Performance = Performance;
window.PreAlert = PreAlert;
window.Reconciliation = Reconciliation;
window.Sidebar = Sidebar;
window.Signature = Signature;
window.Topbar = Topbar;
window.Trucker = Trucker;
window.TruckerEmail = TruckerEmail;
window.VolumeDeviation = VolumeDeviation;
window.Web = Web;
